// extracted by mini-css-extract-plugin
export default {"subTitle":"subTitle___kmJ_W"};